var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectors5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 852,
    height: 852,
    viewBox: "0 0 852 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.386 191.407C152.772 123.433 222.409 72.8386 302.317 46.8748C382.225 20.9112 468.302 20.9112 548.21 46.8749L425.263 425.264L103.386 191.407Z",
    fill: "url(#paint0_linear_61_24)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.387 659.122C54.0011 591.148 27.402 509.285 27.402 425.264C27.402 341.244 54.0011 259.38 103.387 191.407L425.264 425.264L103.387 659.122Z",
    fill: "url(#paint1_linear_61_24)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M548.211 46.8742C628.119 72.8379 697.756 123.432 747.142 191.406C796.528 259.38 823.127 341.244 823.127 425.264L425.265 425.264L548.211 46.8742Z",
    fill: "url(#paint2_linear_61_24)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M548.211 803.654C468.303 829.618 382.226 829.618 302.318 803.654C222.41 777.691 152.773 727.096 103.387 659.122L425.265 425.265L548.211 803.654Z",
    fill: "url(#paint3_linear_61_24)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M823.127 425.264C823.127 509.284 796.528 591.148 747.142 659.122C697.756 727.095 628.119 777.69 548.211 803.654L425.265 425.264L823.127 425.264Z",
    fill: "url(#paint4_linear_61_24)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_24",
    x1: 206.793,
    y1: 307.07,
    x2: 360.005,
    y2: 137.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_24",
    x1: 245.343,
    y1: 596.518,
    x2: 109.538,
    y2: 114.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_24",
    x1: 494.406,
    y1: 183.654,
    x2: 905.434,
    y2: 536.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_61_24",
    x1: 532.538,
    y1: 649.3,
    x2: 308.954,
    y2: 696.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_61_24",
    x1: 478.776,
    y1: 756.578,
    x2: 714.776,
    y2: 355.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9176DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805FDA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectors5);
export default __webpack_public_path__ + "static/media/sectors-5.1025451274a301ac5674bef5c0a06339.svg";
export { ForwardRef as ReactComponent };